export default __webpack_public_path__ + "f200445e1af6a968739a3a4b94fccab2.png";